<template>
    <b-modal
        v-model="isOpen"
        modal-class="vue-need-bootstrap"
        :title-class="titleClass + ' font-weight-bold'"
        :content-class="contentClass"
        ok-only
        no-close-on-esc
        no-close-on-backdrop
        scrollable
        centered
        :no-enforce-focus="!autoFocus"
        :title="title"
        :size="size"
        @ok="emit('ok')"
        @close="emit('closed')"
    >
        <slot />
        <!-- override slots for cases where custom renders are needed -->
        <template v-for="(_, slotName) of slots" v-slot:[slotName]="scope">
            <slot :name="slotName" v-bind="scope" />
        </template>
    </b-modal>
</template>

<script lang="ts" setup>
import { computed, SetupContext, useSlots } from 'vue';

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
    (event: 'ok'): void;
    (event: 'closed'): void;
}>();

const slots: SetupContext['slots'] = useSlots();

const props = withDefaults(
    defineProps<{
        value: boolean;
        size?: string;
        title?: string;
        titleClass?: string;
        contentClass?: string;
        autoFocus?: boolean;
    }>(),
    {
        size: 'md',
        autoFocus: false,
        titleClass: ''
    }
);

const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});
</script>
